// Contenido de los documentos legales — versión 1.2 (Julio 2026)
// Actualizar VERSION al modificar cualquier documento
// v1.2: añadida cláusula "Comunicación entre usuarios" (chat) — pendiente de revisión por asesoría legal

export const LEGAL_VERSION = '1.2';

export const LEGAL_DOCS = {
  terminos: {
    titulo: 'Términos y Condiciones Generales',
    url: '/legal/terminos',
    secciones: [
      {
        titulo: '1. Identificación del titular',
        texto: `En cumplimiento del artículo 10 de la Ley 34/2002 (LSSI-CE), se informa:

Titular: Dorian Robles Utrera
NIF: 79446435L
Domicilio: Taco, 38108 Santa Cruz de Tenerife, Canarias, España
Email de contacto: info@trasteroweb.es
Email de abuso: abuse@trasteroweb.es`,
      },
      {
        titulo: '2. Naturaleza de la plataforma',
        texto: `trasteroweb.es es una plataforma de anuncios clasificados entre particulares (modelo C2C) que actúa exclusivamente como intermediario tecnológico, conforme al artículo 14 de la LSSI-CE y el Reglamento (UE) 2022/2065 sobre Servicios Digitales (DSA).

La plataforma no es parte en las transacciones entre usuarios, no actúa como vendedor ni comprador, y no interviene en la negociación, acuerdo, pago ni entrega entre las partes.

Todas las transacciones —compraventa, trueque o cualquier forma de intercambio— se realizan íntegramente fuera de la plataforma, sin intervención de trasteroweb.es.`,
      },
      {
        titulo: '3. Acceso y registro',
        texto: `3.1 El acceso como visitante es libre y gratuito.
3.2 La publicación de anuncios y el contacto con otros usuarios requiere registro previo.
3.3 El usuario debe ser mayor de 18 años o contar con representación legal acreditada.
3.4 El usuario es responsable de mantener la confidencialidad de sus credenciales.
3.5 Queda prohibida la creación de cuentas con datos falsos o suplantando la identidad de terceros, empresas o entidades.
3.6 trasteroweb.es no verifica la identidad real de los usuarios registrados. El registro se realiza bajo declaración responsable del propio usuario.
3.7 Si detectas que alguien está suplantando tu identidad o la de tu negocio, puedes reportarlo a abuse@trasteroweb.es. La plataforma evaluará el caso y podrá retirar el contenido o suspender la cuenta implicada. trasteroweb.es no asume responsabilidad por los daños causados antes de recibir la notificación.`,
      },
      {
        titulo: '4. Moderación y retirada de contenidos',
        texto: `4.1 trasteroweb.es aplica un sistema de moderación graduado:
• Primera infracción puntual: retirada del anuncio o contenido concreto, sin afectar al resto de la cuenta.
• Infracción grave (artículo ilegal, fraude, suplantación de identidad, contenido prohibido): suspensión temporal de la cuenta completa.
• Reincidencia o infracción muy grave: cancelación permanente de la cuenta y de todos sus contenidos.

La plataforma se reserva el derecho a aplicar directamente la cancelación permanente cuando la gravedad de la infracción así lo justifique, sin necesidad de pasos previos.

4.2 Todas las acciones de moderación se realizan sin previo aviso y sin derecho a compensación económica.
4.3 Conforme al DSA, se habilita un sistema de reclamación interno para que los usuarios puedan recurrir decisiones de moderación en un plazo de 15 días hábiles mediante escrito a info@trasteroweb.es.
4.4 trasteroweb.es colaborará con las autoridades competentes facilitando datos de usuarios ante requerimiento legal debidamente fundado.`,
      },
      {
        titulo: '5. Comunicación entre usuarios',
        texto: `5.1 El chat integrado en trasteroweb.es es una herramienta de mensajería facilitada por la plataforma para que los usuarios se pongan en contacto entre sí con el fin de coordinar la compraventa, trueque o intercambio de artículos.

5.2 El usuario reconoce y acepta que cualquier información personal (incluyendo, sin limitación, número de teléfono, dirección postal, correo electrónico u otros datos de contacto) que decida compartir voluntariamente con otro usuario a través del chat queda bajo su exclusiva responsabilidad y libre elección.

5.3 trasteroweb.es actúa como mero prestador de un servicio de intermediación técnica en las comunicaciones entre usuarios, conforme al artículo 14 de la LSSI-CE y el régimen de exención de responsabilidad de prestadores intermediarios del Reglamento (UE) 2022/2065 (DSA). trasteroweb.es no supervisa, controla, edita ni selecciona el contenido de las comunicaciones entre usuarios de forma previa, sin perjuicio de su compromiso de actuar con diligencia y retirar el acceso ante cualquier denuncia de contenido ilícito puesta en su conocimiento conforme al procedimiento del punto 4.3.

5.4 Se recomienda encarecidamente a los usuarios no compartir datos personales sensibles o innecesarios a través del chat, y extremar la prudencia en la coordinación de encuentros o entregas con terceros desconocidos.`,
      },
      {
        titulo: '6. Legislación aplicable',
        texto: `El presente documento se rige por la legislación española. Para la resolución de conflictos, las partes se someten a los Juzgados y Tribunales del domicilio del usuario, conforme al artículo 90.2 del RDL 1/2007.`,
      },
      {
        titulo: '7. Modificaciones',
        texto: `trasteroweb.es se reserva el derecho a modificar estos términos. Los usuarios serán notificados con 15 días de antelación ante cambios sustanciales. El uso continuado implica la aceptación de los nuevos términos.`,
      },
      {
        titulo: '8. Continuidad del servicio',
        texto: `8.1 trasteroweb.es se reserva el derecho de suspender, modificar o cesar el servicio en cualquier momento, notificando a los usuarios registrados con un preaviso mínimo de 30 días por email.

8.2 En caso de cierre definitivo, trasteroweb.es eliminará todos los datos de usuarios, anuncios e imágenes en un plazo máximo de 90 días desde la comunicación del cese.

8.3 trasteroweb.es no será responsable de los daños directos o indirectos derivados de la interrupción, suspensión o cese del servicio, incluyendo la pérdida de acceso a los anuncios publicados o a las imágenes almacenadas.`,
      },
      {
        titulo: '9. Almacenamiento de imágenes e inactividad de cuenta',
        texto: `9.1 Las imágenes subidas por el usuario se almacenan exclusivamente para mostrar los artículos publicados en la plataforma. trasteroweb.es no es un servicio de almacenamiento de imágenes ni de copias de seguridad. El usuario es responsable de conservar sus propias copias.

9.2 Las imágenes asociadas a anuncios eliminados, vendidos o expirados serán borradas de los servidores de trasteroweb.es en un plazo máximo de 90 días.

9.3 Se considera cuenta inactiva aquella sin ninguna actividad —acceso, publicación, edición o comunicación— durante un período superior a 12 meses consecutivos.

9.4 Antes de proceder a la eliminación de datos por inactividad, trasteroweb.es notificará al usuario en la dirección de email registrada con 30 días de antelación. Si transcurrido ese plazo no se registra actividad ni respuesta, se procederá al borrado definitivo de los anuncios, imágenes y datos asociados a la cuenta.

9.5 trasteroweb.es podrá eliminar imágenes o reducir el espacio de almacenamiento por motivos técnicos o de capacidad, con un preaviso mínimo de 15 días al usuario afectado.`,
      },
    ],
  },

  privacidad: {
    titulo: 'Política de Privacidad',
    url: '/legal/privacidad',
    secciones: [
      {
        titulo: '1. Responsable del tratamiento',
        texto: `El responsable del tratamiento de datos es el titular de trasteroweb.es. Contacto de privacidad: privacidad@trasteroweb.es.

Delegado de Protección de Datos (DPD): No se ha designado DPD al no concurrir los supuestos obligatorios del artículo 37 del RGPD (tratamiento no a gran escala de categorías especiales de datos ni actividad pública). Las consultas en materia de protección de datos pueden dirigirse a privacidad@trasteroweb.es.`,
      },
      {
        titulo: '2. Datos que se recogen',
        texto: `• Nombre, email y contraseña — para gestión de cuenta (base legal: ejecución de contrato, art. 6.1.b RGPD).
• Datos de anuncios publicados (título, descripción, precio, imágenes) — para prestación del servicio.
• Mensajes enviados a través del chat entre usuarios — para facilitar la comunicación entre comprador y publicador (base legal: ejecución de contrato, art. 6.1.b RGPD). Véase la cláusula 5 de los Términos y Condiciones sobre la responsabilidad del usuario en el contenido que comparte por este medio.
• Fecha y hora de aceptación de condiciones — para cumplimiento legal (art. 6.1.c RGPD).
• Logs de acceso del servidor (IP, fecha, ruta) — generados automáticamente por el servidor web para seguridad y cumplimiento legal; no se almacenan en la base de datos de usuarios (base legal: interés legítimo, art. 6.1.f RGPD).

Menores de edad: trasteroweb.es no está dirigido a menores de 18 años y no recoge conscientemente datos de menores. Si se detecta que un menor ha facilitado datos sin consentimiento parental, se procederá a su supresión inmediata. Los padres o tutores pueden solicitarlo a privacidad@trasteroweb.es.`,
      },
      {
        titulo: '3. Conservación de datos',
        texto: `• Datos de cuenta activa: mientras la cuenta esté activa y no se considere inactiva.
• Cuenta inactiva: se considera inactiva tras 12 meses consecutivos sin actividad. El usuario recibirá un aviso por email con 30 días de antelación antes del borrado definitivo (véase cláusula 9 de los Términos y Condiciones).
• Mensajes de chat entre usuarios: se conservan mientras la cuenta de al menos uno de los participantes de la conversación permanezca activa, y se eliminan conforme a las mismas reglas de inactividad o baja de cuenta aplicables a los datos de cuenta.
• Imágenes de anuncios eliminados, vendidos o expirados: borradas en un plazo máximo de 90 días.
• Imágenes en caso de cierre del servicio: borradas en un plazo máximo de 90 días desde la comunicación del cese.
• Datos tras baja voluntaria: 3 años (plazo de prescripción de acciones legales).
• Logs de acceso: 12 meses.
• Aceptaciones de condiciones legales: 5 años.`,
      },
      {
        titulo: '4. Derechos del usuario',
        texto: `Puedes ejercer los derechos de acceso, rectificación, supresión, limitación, portabilidad y oposición enviando solicitud a privacidad@trasteroweb.es con copia de DNI. Plazo de respuesta: 30 días.

Puedes presentar reclamación ante la Agencia Española de Protección de Datos (www.aepd.es).`,
      },
      {
        titulo: '5. Publicidad, perfilado y decisiones automatizadas',
        texto: `trasteroweb.es utiliza Google AdSense, un servicio de publicidad de Google LLC. Este servicio puede utilizar cookies y tecnologías similares para mostrar anuncios personalizados basados en el historial de navegación del usuario (perfilado publicitario). Este tratamiento constituye una decisión automatizada sin intervención humana directa, amparada en el consentimiento del usuario (art. 6.1.a y art. 22 RGPD).

El usuario puede oponerse al perfilado publicitario en cualquier momento desactivando las cookies de publicidad desde el panel de configuración del sitio o desde https://www.google.com/settings/ads.

Puedes consultar la política de privacidad de Google en https://policies.google.com/privacy.`,
      },
      {
        titulo: '6. Transferencias internacionales de datos',
        texto: `El uso de Google AdSense implica la transferencia de datos (dirección IP, datos de navegación) a Google LLC, con sede en Estados Unidos. Esta transferencia está amparada por las Cláusulas Contractuales Tipo aprobadas por la Comisión Europea y por el Marco de Privacidad de Datos UE-EE.UU. (Data Privacy Framework), conforme al art. 46 RGPD.

No se realizan otras transferencias internacionales de datos personales fuera del Espacio Económico Europeo.`,
      },
      {
        titulo: '7. Comunicación de datos a terceros',
        texto: `Los datos no serán cedidos a terceros salvo obligación legal o requerimiento judicial, o proveedores de servicios técnicos bajo acuerdo de encargado de tratamiento conforme al art. 28 RGPD.`,
      },
    ],
  },

  'condiciones-publicador': {
    titulo: 'Condiciones del Publicador',
    url: '/legal/condiciones-publicador',
    secciones: [
      {
        titulo: '1. Declaraciones del publicador',
        texto: `Al publicar un anuncio en trasteroweb.es, el usuario declara y garantiza expresamente:

Capacidad legal: ser mayor de 18 años con plena capacidad jurídica conforme al Código Civil español.

Titularidad: ser el propietario legítimo del artículo o disponer de autorización expresa para su venta. El artículo está libre de cargas, embargos o litigios. El artículo no es un bien robado o de procedencia ilícita (artículo 298 del Código Penal).

Veracidad: la descripción, precio e imágenes corresponden fielmente al artículo real. Se han indicado todos los defectos conocidos relevantes para el comprador.`,
      },
      {
        titulo: '2. Artículos prohibidos',
        texto: `Queda expresamente prohibida la publicación de:
• Estupefacientes o sustancias psicotrópicas (arts. 368-369 CP)
• Armas o explosivos sin licencia (LO 4/2015; RD 137/1993)
• Artículos falsificados o con marcas no autorizadas (Ley 17/2001)
• Obras o software con derechos de autor vulnerados (TRLPI)
• Animales protegidos o especies CITES (Ley 42/2007)
• Medicamentos sujetos a prescripción (Ley 29/2006)
• Contenido que incite al odio o violencia (art. 510 CP)
• Datos personales de terceros (RGPD / LOPD-GDD)
• Contenido sexual con menores (art. 189 CP)
• Artículos de origen ilícito o procedencia dudosa (art. 298 CP)`,
      },
      {
        titulo: '3. Responsabilidad del publicador',
        texto: `El publicador asume plena y exclusiva responsabilidad civil, penal y administrativa respecto a la legalidad del artículo, la exactitud de la información y el cumplimiento de cualquier normativa sectorial aplicable.

El publicador mantendrá indemne a trasteroweb.es frente a cualquier reclamación derivada del incumplimiento de estas condiciones.

trasteroweb.es no es responsable de la autenticidad, estado real, legalidad ni titularidad de los artículos publicados.`,
      },
      {
        titulo: '4. Obligaciones fiscales',
        texto: `El publicador es el único responsable del cumplimiento de sus obligaciones fiscales. Las ganancias patrimoniales derivadas de la venta de bienes entre particulares pueden estar sujetas a declaración en IRPF (artículo 33 de la Ley 35/2006).

trasteroweb.es cumplirá con las obligaciones de información a la Administración Tributaria previstas en la Directiva DAC7 (RD 1080/2023) en la medida en que resulten de aplicación a su modelo de intermediación.`,
      },
      {
        titulo: '5. Transacciones fuera de la plataforma',
        texto: `Los acuerdos y condiciones se fijan libremente entre las partes fuera de la plataforma. trasteroweb.es no procesa, custodia, garantiza ni media en pagos ni entregas.`,
      },
    ],
  },

  cookies: {
    titulo: 'Política de Cookies',
    url: '/legal/cookies',
    secciones: [
      {
        titulo: '1. ¿Qué son las cookies?',
        texto: `Las cookies son pequeños archivos de texto que los sitios web almacenan en tu dispositivo cuando los visitas. Permiten recordar tus preferencias, mantener sesiones iniciadas y analizar el uso del sitio.`,
      },
      {
        titulo: '2. Cookies que utilizamos',
        texto: `Cookies esenciales (propias):
• Sesión de usuario — mantiene tu sesión iniciada mientras navegas.
• Preferencias de tema — recuerda si has elegido tema oscuro o claro.
• Consentimiento de cookies — registra tu elección sobre el uso de cookies (cookieConsent).

Cookies de terceros — publicidad (Google AdSense):
• Google utiliza cookies para mostrar anuncios personalizados basados en tu historial de navegación.
• Estas cookies solo se activan si aceptas todas las cookies.
• Puedes gestionar tus preferencias de publicidad de Google en https://www.google.com/settings/ads`,
      },
      {
        titulo: '3. Base legal',
        texto: `Las cookies esenciales se instalan en base a nuestro interés legítimo en la prestación del servicio (art. 6.1.f RGPD) y no requieren consentimiento previo.

Las cookies de publicidad de terceros se instalan únicamente con tu consentimiento explícito (art. 6.1.a RGPD), que puedes retirar en cualquier momento.`,
      },
      {
        titulo: '4. Cómo gestionar las cookies',
        texto: `Puedes retirar tu consentimiento o cambiar tus preferencias en cualquier momento:

• Borrando las cookies de tu navegador: Configuración → Privacidad → Borrar datos de navegación.
• En Chrome: chrome://settings/cookies
• En Firefox: about:preferences#privacy
• En Safari: Preferencias → Privacidad

Al borrar las cookies, el banner de consentimiento volverá a aparecer en tu próxima visita.

También puedes desactivar la publicidad personalizada de Google en: https://www.google.com/settings/ads`,
      },
      {
        titulo: '5. Más información',
        texto: `Para más información sobre el tratamiento de tus datos personales, consulta nuestra Política de Privacidad en /legal/privacidad.

Contacto: privacidad@trasteroweb.es`,
      },
    ],
  },

  'condiciones-comprador': {
    titulo: 'Condiciones del Comprador e Interesado',
    url: '/legal/condiciones-comprador',
    secciones: [
      {
        titulo: '1. Rol de la plataforma',
        texto: `trasteroweb.es actúa únicamente como tablón de anuncios digital. La plataforma no es parte en la transacción, no verifica los artículos publicados y no garantiza la exactitud de los anuncios.`,
      },
      {
        titulo: '2. Responsabilidad del comprador',
        texto: `El comprador asume que:
• La verificación del estado, legalidad y titularidad del artículo es responsabilidad suya antes de cerrar cualquier acuerdo.
• Los acuerdos se realizan directamente con el publicador, fuera de la plataforma.
• trasteroweb.es no responde de fraudes, impagos, artículos no conformes ni disputas entre las partes.

Se recomienda al comprador:
• Verificar la identidad del vendedor antes de realizar cualquier pago.
• Inspeccionar el artículo en persona cuando sea posible.
• No realizar pagos anticipados a personas desconocidas.
• Desconfiar de precios inusualmente bajos respecto al valor de mercado.`,
      },
      {
        titulo: '3. Exención de responsabilidad de trasteroweb.es',
        texto: `trasteroweb.es no asume responsabilidad por el contenido, veracidad o legalidad de los anuncios, fraudes o incumplimientos entre las partes, ni daños derivados del uso de la plataforma.

Esta exención es de aplicación conforme al artículo 16 de la LSSI-CE y el artículo 6 del Reglamento DSA.`,
      },
      {
        titulo: '4. Transacciones en trueque',
        texto: `En operaciones de permuta o trueque, ambas partes actúan simultáneamente como publicador e interesado, asumiendo en cada rol las responsabilidades descritas en estas condiciones y en las Condiciones del Publicador.`,
      },
    ],
  },
};